import { Button, Paper, Typography } from "@mui/material";
import { LocationCategoryTag } from "./LocationCategoryTag";

export default function MapLocationModal({
  setSidebarOpen,
  setPointDetail,
  selectedLocation,
}) {
  const handleMoreInformationClick = () => {
    setSidebarOpen(true);
    setPointDetail(true);
  };

  return (
    <Paper variant="map-popup">
      <LocationCategoryTag
        text={selectedLocation.category.name}
        variant={`category--${selectedLocation.category.name}`}
        iconCategory={true}
      />

      <Typography variant="h5" component="p" className="location-name">
        {selectedLocation.name}
      </Typography>
      <Typography variant="body1" component="p" className="location-address">
        {selectedLocation.address}
      </Typography>
      <Button
        variant="outlined"
        color="secondary"
        onClick={handleMoreInformationClick}
      >
        Mehr Informationen
      </Button>
    </Paper>
  );
}
